import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-column gr-8" },
    [
      _c("div", [
        _c(
          "div",
          {
            staticClass: "mb-4",
            class: _setup.isMobile ? "text-subtitle-1" : "text-h6",
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.t(
                    "Как зарегистрироваться самостоятельно",
                    _setup.options
                  )
                ) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "ol",
          { staticClass: "d-flex flex-column gr-2 text-body-1 pl-5 mb-2" },
          [
            _c("li", [
              _vm._v(
                _vm._s(
                  _setup.t(
                    "Убедитесь, что выбран верный город для поиска",
                    _setup.options
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _setup.t("Найдите свой профиль по ФИО на {site}", {
                      ..._setup.options,
                      site: _setup.context.request.country.is_russia
                        ? "ПроДокторов"
                        : "YDoc",
                    })
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(_setup.t("Нажмите кнопку «Это вы?»", _setup.options))
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                _vm._s(_setup.t("Продолжите регистрацию", _setup.options))
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "text-body-1 primary--text link-decoration-none",
            attrs: {
              href: _setup.context.request.country.is_russia
                ? "https://help.prodoctorov.ru/kak-doktoru-zaregistrirovatsya-na-portale-prodoktorov/"
                : "https://help.ydoc.me/kak-doktoru-zaregistrirovatsya-na-portale-ydoc/",
              target: "_blank",
              rel: "noopener noreferrer",
            },
          },
          [_vm._v(_vm._s(_setup.t("Подробнее в статье", _setup.options)))]
        ),
      ]),
      _vm._v(" "),
      _setup.isMobile
        ? _c(
            VBtn,
            {
              attrs: { color: "primary", depressed: "" },
              on: { click: _setup.openSearch },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_setup.t("Найти профиль", _setup.options)) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _setup.companyContacts.length
        ? _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c("div", { staticClass: "flex-grow-1" }, [
                _c(
                  "div",
                  {
                    staticClass: "mb-4",
                    class: _setup.isMobile ? "text-subtitle-1" : "text-h6",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _setup.t(
                            "С помощью наших специалистов",
                            _setup.options
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-body-1" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _setup.t(
                          "Напишите свои ФИО и город нам в чат:",
                          _setup.options
                        )
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ol",
                  { staticClass: "text-body-1 pl-5 mb-3" },
                  _vm._l(
                    _setup.companyContacts,
                    function (companyContact, index) {
                      return _c("li", { key: index }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(companyContact.text) +
                            "\n          "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "primary--text link-decoration-none",
                            attrs: {
                              href: companyContact.href,
                              target: "_blank",
                              rel: "noopener noreferrer",
                            },
                          },
                          [_vm._v(_vm._s(companyContact.hrefText))]
                        ),
                        _vm._v(
                          _vm._s(
                            companyContact.hasQr
                              ? _setup.t(
                                  " или отсканируйте QR-код.",
                                  _setup.options
                                )
                              : "."
                          ) + "\n        "
                        ),
                      ])
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-body-1" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _setup.t(
                          "Ответим в течение 1 рабочего дня.",
                          _setup.options
                        )
                      ) +
                      "\n      "
                  ),
                ]),
              ]),
              _vm._v(" "),
              !_setup.isMobile
                ? _c(VImg, {
                    staticClass: "flex-grow-0",
                    attrs: {
                      src: _setup.qrSrc,
                      width: "150",
                      height: "150",
                      alt: _setup.t("QR-код", _setup.options),
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }